import * as Sentry from '@sentry/gatsby';
import { routes } from 'constants/routes';
import { navigate } from 'gatsby';
import { ThemeProvider } from 'providers/ThemeProvider';
import { useEffect } from 'react';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { GlobalStyles } from 'twin.macro';
import { LOG } from 'utils/helper';


LOG('process.env.GATSBY_ENVIRONMET', process.env.GATSBY_ENVIRONMET);
LOG('process.env.NODE_ENV', process.env.NODE_ENV);

function ErrorFallback({ error, resetErrorBoundary }) {
	useEffect(() => {
		if(error) {
			Sentry.captureException(error);
		}
	}, [error]);

	const navigateToApplication = () => {
		navigate(routes.DASHBOARD);
		resetErrorBoundary();
	};

	return (
		<div className='flex flex-col items-center justify-center m-20'>
			<p>Coś poszło nie tak.</p>
			<button tw='bg-blue-1 text-09 text-light rounded-10 px-05 my-05' onClick={resetErrorBoundary}>Spróbuj ponownie</button>
			<button tw='bg-green-1 text-09 text-light rounded-10 px-05' onClick={navigateToApplication}>Wróć do aplikacji</button>
		</div>
	);
}

export default function ProvidersWrapper({ children }) {
	return (
		<ErrorBoundary FallbackComponent={ErrorFallback}>
			<ThemeProvider>
				<GlobalStyles />
				{children}
			</ThemeProvider>
		</ErrorBoundary>
	);
}
